import { toast } from "react-hot-toast"

type ToastType = "success" | "error" | "warning"

export const showToast = (type:ToastType , message:string  )=> {
    // react-hot-toast has no warning type: an orange-bordered plain toast.
    if (type === "warning") {
        toast(message, {
            icon: "⚠️",
            duration: 6000,
            position: "top-center",
            className: 'text-[30px] ',
            style: {
                minWidth: '50vh',
                maxWidth: '80vh',
                border: '2px solid #f59e0b',
                background: '#fffbeb',
                color: '#92400e',
            },
        })
        return
    }
    toast[type](message , {
        duration: 3000,
        position: "top-center",
        className:'text-[30px] ',
        style: {
            minWidth:'50vh',
            maxWidth:'80vh'
        }

    })
}